module.exports = __webpack_public_path__ + "static/media/robot.8a2aaa6b.svg";